import { c as e, cB as o, cM as i, cE as r, cNotM as t } from "./ghl-ui.es628.js";
import { fadeInScaleUpTransition as n } from "./ghl-ui.es1284.js";
const l = e([o("time-picker", `
 z-index: auto;
 position: relative;
 `, [o("time-picker-icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), i("disabled", [o("time-picker-icon", `
 color: var(--n-icon-color-disabled-override);
 `)])]), o("time-picker-panel", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 font-size: var(--n-item-font-size);
 border-radius: var(--n-border-radius);
 margin: 4px 0;
 min-width: 104px;
 overflow: hidden;
 background-color: var(--n-panel-color);
 box-shadow: var(--n-panel-box-shadow);
 `, [n(), o("time-picker-actions", `
 padding: var(--n-panel-action-padding);
 align-items: center;
 display: flex;
 justify-content: space-evenly;
 `), o("time-picker-cols", `
 height: calc(var(--n-item-height) * 6);
 display: flex;
 position: relative;
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-panel-divider-color);
 `), o("time-picker-col", `
 flex-grow: 1;
 min-width: var(--n-item-width);
 height: calc(var(--n-item-height) * 6);
 flex-direction: column;
 transition: box-shadow .3s var(--n-bezier);
 `, [i("transition-disabled", [r("item", "transition: none;", [e("&::before", "transition: none;")])]), r("padding", `
 height: calc(var(--n-item-height) * 5);
 `), e("&:first-child", "min-width: calc(var(--n-item-width) + 4px);", [r("item", [e("&::before", "left: 4px;")])]), r("item", `
 cursor: pointer;
 height: var(--n-item-height);
 display: flex;
 align-items: center;
 justify-content: center;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 background: #0000;
 text-decoration-color: #0000;
 color: var(--n-item-text-color);
 z-index: 0;
 box-sizing: border-box;
 padding-top: 4px;
 position: relative;
 `, [e("&::before", `
 content: "";
 transition: background-color .3s var(--n-bezier);
 z-index: -1;
 position: absolute;
 left: 0;
 right: 4px;
 top: 4px;
 bottom: 0;
 border-radius: var(--n-item-border-radius);
 `), t("disabled", [e("&:hover::before", `
 background-color: var(--n-item-color-hover);
 `)]), i("active", `
 color: var(--n-item-text-color-active);
 `, [e("&::before", `
 background-color: var(--n-item-color-hover);
 `)]), i("disabled", `
 opacity: var(--n-item-opacity-disabled);
 cursor: not-allowed;
 `)]), i("invalid", [r("item", [i("active", `
 text-decoration: line-through;
 text-decoration-color: var(--n-item-text-color-active);
 `)])])])])]);
export {
  l as default
};
